import Vue from 'vue'
import App from './App.vue'
import router from "@/router"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
import ChanPin from './components/lunbo'


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(BaiduMap, {
    ak: 'RWpZBcLsPUKyclnBdYtbZHi2Yd0ngYIM'
});
Vue.use(ChanPin);


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
